import { j as t } from "../../../jsx-runtime-B3iL8JI7.js";
import * as e from "@radix-ui/react-toast";
import S from "./Alert.styles.js";
import "../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import r from "../../atoms/Icon/Icon.js";
import f from "../../../tailwindConfig/bclTwMerge.js";
import v from "../../atoms/Button/IconButton/IconButton.js";
import "@radix-ui/react-checkbox";
import "../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import "../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import "../../atoms/TextField/TextField.styles.js";
import "../../atoms/TextLink/TextLink.styles.js";
import "../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../atoms/RadioItem/RadioItem.styles.js";
const z = ({
  defaultOpen: s,
  variant: i = "error",
  icon: o,
  hasClose: a = !1,
  closeHandler: l,
  children: c
}) => {
  const {
    base: m,
    viewPort: n,
    variant: p,
    description: d,
    descriptionImage: x,
    actionButton: j,
    icon: h,
    closeIcon: u
  } = S, y = f(m, p[i]);
  return /* @__PURE__ */ t.jsxs(e.Provider, { children: [
    /* @__PURE__ */ t.jsxs(e.Root, { className: y, open: s, role: "listitem", children: [
      /* @__PURE__ */ t.jsx(e.Description, { asChild: !0, children: /* @__PURE__ */ t.jsxs("div", { className: d, children: [
        o && /* @__PURE__ */ t.jsx(
          "div",
          {
            "aria-hidden": !0,
            "data-testid": "alert-icon",
            className: x,
            children: /* @__PURE__ */ t.jsx(r, { className: h, icon: o })
          }
        ),
        /* @__PURE__ */ t.jsx("div", { "data-testid": `alert-${i}`, children: c })
      ] }) }),
      a && /* @__PURE__ */ t.jsx(e.Action, { asChild: !0, altText: "Close", children: /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "ghost",
          "aria-label": "Close",
          className: j,
          iconName: "close",
          onClick: l,
          children: /* @__PURE__ */ t.jsx(
            r,
            {
              icon: "xmark",
              className: u,
              "data-testid": "alert-close"
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsx(e.Viewport, { className: n })
  ] });
};
export {
  z as default
};
